import { EditableSettingEdit } from './EditableSettingEdit';
import { EditableSettingList } from './EditableSettingList';
import { EditableSettingShow } from './EditableSettingShow';

export const edit = EditableSettingEdit;
export const list = EditableSettingList;
export const show = EditableSettingShow;
